import { z } from 'zod';
import { makeDraftClaimLineItemWithReasonLoader } from '~/utils/routing';

const paramsSchema = z.object({
  store: z.string(),
  idFromPlatform: z.string(),
});

export const { loader, useLoaderData: useShippingProtectionData } =
  makeDraftClaimLineItemWithReasonLoader(({ context, params }) => {
    const { draftClaimLineItem } = context;
    const { store, idFromPlatform } = paramsSchema.parse(params);

    if (!context.order?.wasShippingProtected) {
      return new Error('Order does not have shipping protection');
    }

    return {
      reasonId: draftClaimLineItem.reasonId,
      shippingProtectionUrl: `/${store}/reorder/${idFromPlatform}`,
    };
  });
